const avatarColors = ['secondary-green', 'secondary-yellow', 'secondary-pink'];
const avatarColorsCompass = ['random-green', 'random-pink', 'random-yellow'];

// Probably legacy, used in AvatarRandomized.vue
const randAvatarColor = (firstname, lastname) => {
    const chars = (firstname ? firstname.length : 0) + (lastname ? lastname.length : 0);
    const color = avatarColors[chars % avatarColors.length];
    return `avatar ${color}-bkg`;
};

const randAvatarColorFullname = (fullname) => {
    const fullNameLength = fullname ? fullname.replace(/\s/g, '').length : 0;
    const color = avatarColorsCompass[fullNameLength % avatarColorsCompass.length];
    return `colors-component-background-avatar-${color}`;
};

const getAvatarObject = (firstname, lastname, avatar) => {
    return {
        initials: `${firstname[0]}${lastname[0]}`,
        photo: avatar,
        colorType: randAvatarColorFullname(`${firstname} ${lastname}`),
    };
};

export { randAvatarColor, randAvatarColorFullname, getAvatarObject };
